import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import Page from "../../components/layout/Page";
import { Button, Loading } from "../../components/widgets";
import * as alertActions from "../../redux/actions/alerting";
import Permissions from "../../permissions";
import AlertsListTable from "../../components/alerts/AlertsListTable";
import AlertsSummaryFilter from "../../components/alerts/AlertsSummaryFilter";
import queryString from "query-string";
import PagingControl from "../../components/widgets/PagingControl";

import "./AlertsList.css";

export const PAGE_SIZE = 10;

export const ALERT_TYPE_OPTIONS = {
  OFFLINE_24H: { label: "Offline", description: "24 hours" },
  OPMETER_ERROR: { label: "Meter", description: "comms errors" },
  INVERTER_ERROR: { label: "Inverter", description: "comms errors" },
  BELOW_DOD: { label: "Battery", description: "below min. DoD" },
};

const mapStateToProps = state => ({
  alerts: state.alerting.alerts,
  alertsPageMeta: state.alerting.alertsPageMeta,
  loading: state.alerting.loading,
  user: state.user,
  location: state.router.location,
});

const mapDispatchToProps = dispatch => {
  return {
    alertActions: bindActionCreators(alertActions, dispatch),
  };
};

class AlertsList extends Component {
  constructor(props) {
    super(props);
    const search = queryString.parse(props.location.search);

    let limit = PAGE_SIZE;
    if (search.limit !== undefined) {
      limit = parseInt(search.limit, 10);
    }

    let offset = 0;
    if (search.offset !== undefined) {
      offset = parseInt(search.offset, 10);
    }

    let silencedFirst = false;
    if (search.silencedFirst !== undefined) {
      silencedFirst = search.silencedFirst.toLowerCase() === "true";
    }

    let filters = null;
    if (search.filters !== undefined) {
      filters = search.filters;
    }

    this.state = {
      limit,
      offset,
      alertsFilters: filters,
      showSilencedAlerts: silencedFirst,
    };
    this.updateLimitPerPage = this.updateLimitPerPage.bind(this);
  }

  componentDidMount = () => {
    this.props.alertActions.fetchAlerts(
      this.state.limit,
      this.state.offset,
      this.state.showSilencedAlerts,
      this.state.alertsFilters
    );
  };

  componentWillUnmount = () => {
    if (this.refreshTimeout) {
      clearTimeout(this.refreshTimeout);
    }
    this.props.alertActions.clearAlerts();
  };

  componentWillReceiveProps(nextProps) {
    const nextSearch = queryString.parse(nextProps.location.search);
    if (
      this.props.location.search &&
      nextProps.location.search &&
      this.props.location.search !== nextProps.location.search
    ) {
      let silencedFirst = false;
      if (nextSearch.silencedFirst !== undefined) {
        silencedFirst = nextSearch.silencedFirst.toLowerCase() === "true";
      }
      this.props.alertActions.fetchAlerts(
        nextSearch.limit,
        nextSearch.offset,
        silencedFirst,
        nextSearch.filters
      );
      this.setState({
        limit: parseInt(nextSearch.limit, 10),
        offset: parseInt(nextSearch.offset, 10),
        alertsFilters: nextSearch.filters,
        showSilencedAlerts: silencedFirst,
      });
    }
  }

  updateAlertsFromFilter = filters => {
    this.setState({
      alertsFilters: filters,
    });
    this.getPage(this.state.limit, 0, this.state.showSilencedAlerts, filters);
  };

  updateLimitPerPage(limit) {
    this.setState({ limit });
  }

  showSilencedAlerts = () => {
    this.setState({ showSilencedAlerts: true });
    this.updateUrl(this.state.limit, 0, true, this.state.alertsFilters);
  };

  hideSilencedAlerts = () => {
    this.setState({ showSilencedAlerts: false });
    this.updateUrl(this.state.limit, 0, false, this.state.alertsFilters);
  };

  getPage = (limit, offset, showSilenced, filters) => {
    this.updateUrl(limit, offset, showSilenced, filters);
  };

  calculateNewOffset(value) {
    if (value === "SILENCED" && this.state.offset > 0) {
      if (this.state.offset + 1 === this.props.alertsPageMeta.counts.filteredTotal) {
        return this.state.offset - this.state.limit;
      }
    }
    return this.state.offset;
  }

  setAlertSilence = (value, alert) => {
    const offset = this.calculateNewOffset(value);
    if (value === "SILENCED") {
      this.props.alertActions.silenceAlert(
        alert.uid,
        this.props.alerts,
        this.props.alertsPageMeta,
        this.props.user.account.id,
        this.state.showSilencedAlerts
      );
    }
    if (value === "UNSILENCE") {
      this.props.alertActions.unsilenceAlert(
        alert.uid,
        this.props.alerts,
        this.props.alertsPageMeta,
        this.props.user.account.id,
        this.state.showSilencedAlerts
      );
    }

    if (
      this.urlNeedsUpdate(
        this.state.limit,
        offset,
        this.state.showSilencedAlerts,
        this.state.alertsFilters
      )
    ) {
      this.updateUrl(
        this.state.limit,
        offset,
        this.state.showSilencedAlerts,
        this.state.alertsFilters
      );
    } else {
      this.props.alertActions.fetchAlerts(
        this.state.limit,
        offset,
        this.state.showSilencedAlerts,
        this.state.alertsFilters
      );
    }
  };

  updateUrl = (limit, offset, showSilenced, filters) => {
    let url = `${this.props.location.pathname}?limit=${limit}&offset=${offset}&silencedFirst=${showSilenced}`;
    if (filters) {
      url = `${url}&filters=${filters}`;
    }
    this.props.history.push(url);
  };

  haveFiltersChanged = filters => {
    return filters && this.state.alertsFilters && filters !== this.state.alertsFilters;
  };

  urlNeedsUpdate = (limit, offset, showSilenced, filters) => {
    return (
      limit !== this.state.limit ||
      offset !== this.state.offset ||
      showSilenced !== this.state.showSilencedAlerts ||
      this.haveFiltersChanged(filters)
    );
  };

  render() {
    const silencedTotal = this.props.alertsPageMeta ? this.props.alertsPageMeta.counts.silenced : 0;

    return (
      <Page key="alerts-list" permission={Permissions.fleet.status.alerts.any}>
        <Page.Header title="Alerts">
          <Page.Header.Actions>
            {silencedTotal !== 0 && !this.props.loading ? (
              <Button
                id="show-silenced"
                type="secondary"
                onClick={
                  this.state.showSilencedAlerts ? this.hideSilencedAlerts : this.showSilencedAlerts
                }
              >
                {this.state.showSilencedAlerts ? "Hide" : "Show"} {silencedTotal} silenced alert
                {silencedTotal > 1 ? "s" : ""}
              </Button>
            ) : null}
          </Page.Header.Actions>
        </Page.Header>
        <Page.Content>
          <div className="alerts-list-section">
            {this.props.alertsPageMeta ? (
              <AlertsSummaryFilter
                initialFilters={this.state.alertsFilters}
                alertCounts={this.props.alertsPageMeta.counts}
                alertTypeOptions={ALERT_TYPE_OPTIONS}
                fetchAlerts={this.updateAlertsFromFilter}
              />
            ) : null}
            {this.props.loading ? (
              <Loading />
            ) : (
              <AlertsListTable
                noAlertsType="fleet"
                alerts={this.props.alerts}
                alertCounts={this.props.alertsPageMeta.counts}
                filters={this.state.alertsFilters}
                timezone={this.props.user.account.timezone}
                history={this.props.history}
                setAlertSilence={this.setAlertSilence}
                alertTypeOptions={ALERT_TYPE_OPTIONS}
                user={this.props.user}
                loading={this.props.loading}
              />
            )}
          </div>
          {this.props.alertsPageMeta &&
          this.props.alertsPageMeta.counts.total !== 0 &&
          !this.props.loading ? (
            <footer className="page-controls">
              <PagingControl
                limit={this.state.limit}
                offset={this.state.offset}
                totalItems={this.props.alertsPageMeta.counts.filteredTotal}
                itemName="alert"
                onPageChange={(limit, offset) =>
                  this.getPage(
                    limit,
                    offset,
                    this.state.showSilencedAlerts,
                    this.state.alertsFilters
                  )
                }
                onChangeResultsPerPage={this.updateLimitPerPage}
              />
            </footer>
          ) : null}
        </Page.Content>
      </Page>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AlertsList);
